import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../components/hooks/LanguageContext";
import Home from "../home/Home";
import GeoMap from "../geo/GeoMap";
import "../../assets/css/NotFound.css";

const copy = {
    ru: {
        code: "404",
        title: "Этот гекс пустой",
        text: "Страницы нет на карте. Координаты сбились, либо адрес никогда не существовал.",
        home: "На главную",
        map: "Открыть карту",
    },
    en: {
        code: "404",
        title: "This hex is empty",
        text: "Nothing is mapped here. The coordinates drifted, or this address never existed.",
        home: "Back home",
        map: "Open the map",
    },
};

function Hex({ className, style }) {
    return (
        <svg className={className} style={style} viewBox="0 0 100 86" aria-hidden="true">
            <polygon points="25,3 75,3 97,43 75,83 25,83 3,43" />
        </svg>
    );
}

const NotFound = () => {
    const { language } = useLanguage();
    const t = copy[language] || copy.en;

    return (
        <section className="not-found" aria-labelledby="not-found-title">
            <div className="not-found-grid" aria-hidden="true">
                {Array.from({ length: 18 }).map((_, i) => (
                    <Hex key={i} className={`not-found-hex delay-${i % 6}`} />
                ))}
            </div>
            <div className="not-found-card">
                <div className="not-found-code" aria-hidden="true">
                    <Hex className="not-found-code-hex" />
                    <span>{t.code}</span>
                </div>
                <h1 id="not-found-title">{t.title}</h1>
                <p>{t.text}</p>
                <div className="not-found-actions">
                    <Link className="not-found-btn primary" to={Home.link}>{t.home}</Link>
                    <Link className="not-found-btn" to={GeoMap.link}>{t.map}</Link>
                </div>
            </div>
        </section>
    );
};

NotFound.link = "*";

export default NotFound;
